(function() {
  function initHeroGameplans(section) {
    var headline = section.querySelector('[data-hero-gp-headline]');
    if (!headline) return;

    /* ── Split headline text into individually animatable chars ── */
    var words = headline.querySelectorAll('em, i, span');
    /* If there are no wrapped elements, treat the whole headline as one block */
    var targets = [];

    if (words.length === 0) {
      /* Plain text (including dynamic-source values, which arrive wrapped in
         <p>…</p> and, in the theme editor, surrounded by Shopify's
         <!-- BEGIN/END SETTING --> comment nodes). Walk the real TEXT NODES
         only and wrap each character — never rebuild innerHTML as a string, or
         those tags/comment markers leak in and render as visible text. Element
         nodes (<p>, <br>, <em>) and comment nodes are left untouched. */
      var walker = document.createTreeWalker(headline, NodeFilter.SHOW_TEXT, null);
      var textNodes = [];
      var node;
      while ((node = walker.nextNode())) { textNodes.push(node); }

      textNodes.forEach(function(textNode) {
        var text = textNode.nodeValue;
        if (!text || text.trim() === '') return;
        var frag = document.createDocumentFragment();
        /* Split on whitespace but keep the whitespace tokens so spacing is preserved */
        text.split(/(\s+)/).forEach(function(part) {
          if (part === '') return;
          if (/^\s+$/.test(part)) {
            frag.appendChild(document.createTextNode(part));
            return;
          }
          var wordSpan = document.createElement('span');
          wordSpan.className = 'm-hero-gp__word';
          for (var c = 0; c < part.length; c++) {
            var charSpan = document.createElement('span');
            charSpan.className = 'm-hero-gp__char';
            charSpan.textContent = part[c]; /* textContent escapes any literal < or > */
            wordSpan.appendChild(charSpan);
          }
          frag.appendChild(wordSpan);
        });
        textNode.parentNode.replaceChild(frag, textNode);
      });
    }

    targets = headline.querySelectorAll('.m-hero-gp__char');

    /* ── Animate chars in ── */
    if (targets.length) {
      targets.forEach(function(char, i) {
        char.style.display = 'inline-block';
        char.style.opacity = '0';
        char.style.transform = 'translateY(120%) rotate(8deg)';
        char.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
        char.style.transitionDelay = (0.3 + i * 0.03) + 's';
      });

      /* Trigger after a micro-delay so the transition fires */
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          targets.forEach(function(char) {
            char.style.opacity = '1';
            char.style.transform = 'translateY(0) rotate(0deg)';
          });
        });
      });
    }

    /* ── Fade in subtitle + CTA row ── */
    var sub = section.querySelector('.m-hero-gp__sub');
    var ctaRow = section.querySelector('.m-hero-gp__cta-row');

    [sub, ctaRow].forEach(function(el, idx) {
      if (!el) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
      el.style.transitionDelay = (0.8 + idx * 0.2) + 's';

      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        });
      });
    });
  }

  /* ── Init on page load ── */
  document.querySelectorAll('[data-section-type="hero-gameplans"]').forEach(initHeroGameplans);

  /* ── Re-init in Shopify editor ── */
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('[data-section-type="hero-gameplans"]');
      if (section) initHeroGameplans(section);
    });
  }
})();
